import { InjectionToken, inject } from '@angular/core';
import { TeamStore } from './team.store';
import { ITeamStore } from './team.public';

export const TEAM_STORE = new InjectionToken<ITeamStore>('TEAM_STORE', {
    providedIn: 'root',
    factory: () => inject(TeamStore) as ITeamStore,
});
